<template>
  <div class="confirm-purchase-form">
    <div class="addons-list">
      <inline-addon-card
        v-for="(addon, idx) in features"
        :key="idx"
        :addon="addon"
      />
    </div>

    <div v-if="showPlans">
      <div
        v-if="features.length"
        class="purchase-addon-note"
      >
        {{ $t('subscription.subscribe-required-note') }}
      </div>
      <plans-cycle-switch
        v-if="active && !canUpgrade"
        v-model="cycle"
      />
      <pricing-cards
        :monthly="cycle === 'monthly'"
        @select="handleSelectPackage"
      />
    </div>
    <div
      v-else-if="features.length"
      class="purchase-addon-note"
    >
      {{ $t('subscription.purchase-addon-note') }}
    </div>

    <div class="policies">
      <div v-if="onlinePaymentIncluded">
        <online-payment-policy />
      </div>
      <div v-else>
        <payment-policy :addons="addons" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import InlineAddonCard from '@/views/admin/purchase/components/InlineAddonCard'
import PricingCards from '@/views/admin/purchase/components/PricingCards'
import PlansCycleSwitch from '@/views/admin/purchase/components/PlansCycleSwitch'
import OnlinePaymentPolicy from '@/views/admin/purchase/components/OnlinePaymentPolicy'
import PaymentPolicy from '@/views/admin/purchase/components/PaymentPolicy'
import SetupWizardStepMixin from '@/mixins/setup-wizard-step-mixin'

export default {
  name: 'ConfirmPurchaseForm',
  components: {
    OnlinePaymentPolicy,
    PaymentPolicy,
    PricingCards,
    PlansCycleSwitch,
    InlineAddonCard,
  },
  mixins: [SetupWizardStepMixin],
  props: {
    addons: {
      type: Array,
      default: () => [],
    },
    upgrade: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedPackage: null,
    }
  },
  computed: {
    ...mapGetters({
      isFreeSubscription: 'subscription/freeSubscription',
      isTrial: 'subscription/isTrial',
      showPlans: 'purchase/showPlans',
      canUpgrade: 'purchase/canUpgrade',
    }),
    ...mapFields('purchase', ['plan', 'cycle', 'features']),
    onlinePaymentIncluded() {
      return this.features.find(addon => addon.slug === 'online_payment')
    },
  },
  watch: {
    plan() {
      this.updateNextButtonStatus()
    },
  },
  mounted() {
    this.$nextTick(() => this.updateNextButtonStatus())
  },
  methods: {
    handleSelectPackage(selectedPackage) {
      this.plan = selectedPackage
      this.$emit('select', selectedPackage)
      this.$emit('next')
    },
    updateNextButtonStatus() {

      //      if (!this.active) return
      //      this.disableSubmit(this.showPlans && !this.plan?.id)
    },
    async submit() {
      if (this.showPlans && !this.plan?.id) {
        throw new Error(this.$t('payment.please-select-plan'))
      }
    },
  },
}
</script>

<style lang="scss">
.confirm-purchase-form {
  .purchase-addon-note {
    color: var(--description-color);
    font-size: 14px;
    line-height: 1.56;
    font-weight: 500;
    margin: 15px 0 17px;
  }

  .policies {
    margin-top: 58px;
  }

  .subscribe-now-word {
    font-size: 24px;
  }
}
</style>
